import React from 'react';
import useFilterModalContext from '../useFilterModalContext';
import useSearchParams from '../../../useSearchParams';

const Footer = () => {
  const {query, setQuery} = useSearchParams();
  const {onClose} = useFilterModalContext();

  const clearQuery = () => {
    setQuery({
      ...query,
      assignees: [],
      types: [],
      priorities: [],
      prospectScore: undefined,
      totalScoreRanks: [],
    });
  };

  return (
    <div className="flex items-center justify-end px-6 py-4 gap-4 bg-background rounded-b">
      <button
        className="cursor-pointer w-32 h-10 flex items-center justify-center rounded border-none bg-transparent text-primary font-bold"
        onClick={clearQuery}
      >
        全ての条件をクリア
      </button>
      <button
        className="cursor-pointer w-32 h-10 flex items-center justify-center rounded bg-white border border-border text-foreground-light font-bold"
        onClick={() => onClose()}
      >
        閉じる
      </button>
    </div>
  );
};

export default Footer;
